module.exports = __webpack_public_path__ + "static/media/pancakeswap.548f49d0.jpeg";